<div class="wrap">
  <div
    *ngIf="{ route: currentRoute$ | async } as currentRoute"
    class="left-slot"
  >
    <ng-container *ngIf="(shouldDisplayTitle$ | async) === false">
      <ng-container *ngIf="(shouldDisplayBackButton$ | async) === false">
        <div class="logo" (click)="onLogoClick()">
          <app-svg-icon
            [name]="
              (newProducts$ | async) !== null &&
              (newProducts$ | async)?.length! > 0
                ? 'new-products-logo'
                : 'logo-small'
            "
          ></app-svg-icon>
        </div>
      </ng-container>
      <ng-container *ngIf="shouldDisplayBackButton$ | async">
        <div class="back-button" (click)="onBackButtonClick()">
          <app-svg-icon [name]="'arrow-back'"></app-svg-icon>
        </div>
      </ng-container>
    </ng-container>

    <ng-container *ngIf="shouldDisplayTitle$ | async">
      <div class="title">
        {{
          "@components.header.titleByRoute." + currentRoute.route | translate
        }}
      </div>
    </ng-container>
  </div>
  <div class="right-slot">
    <app-delivery-selector
      *ngIf="
        (shouldDisplayDeliveryAddress$ | async) ||
        (shouldDisplayInstorePurchaseAddress$ | async)
      "
      [location]="displayedLocation$ | async"
      [isInstoreMode]="!!(shouldDisplayInstorePurchaseAddress$ | async)"
    ></app-delivery-selector>
  </div>
</div>
